export const LeaderboardCTPRangeTournament = `query getLeaderboardCTPRangeTournament($tournamentId: ID!) {
  base: node(id: $tournamentId) {
    ... on Tournament {
      type
    }
  }
  closestToPinTournament: node(id: $tournamentId) {
    ...ClosestToPinTournament
  }
}
  
fragment ClosestToPinTournament on ClosestToPinTournament {
  courseInstanceId
  course {
    id
    displayName
    availableFromDate
    availableUntilDate
    difficulty
    dayImage: image(kind: SPLASH) {
      url
    }
    description
    courseLocation
    courseIdentifier
    courseInstanceId
    tags
    tees {
      courseDistance
      name
    }
    allTeeHoles: holes(holeTypes: PAR3_HOLES) {
      holeNumber
      tees {
        groupId
        distance
      }
      images {
        url
      }
    }
    maleTeeHoles: holes(holeTypes: PAR3_HOLES, gender: MALE) {
      holeNumber
      tees {
        groupId
        distance
      }
    }
    femaleTeeHoles: holes(holeTypes: PAR3_HOLES, gender: FEMALE) {
      holeNumber
      tees {
        groupId
        distance
      }
    }
  }
  unit
  attempts
  allowMultipleTournamentAttempts
  hasEndDate
  holes {
    holeNumber
  }
  availableHoles
  femaleTee
  maleTee
  gameSettings {
    fairwayFirmness
    greenFirmness
    greenStimp
    pinDifficulty
    windSpeed
  }
}
`;
